import * as React from 'react';

import { Button, Modal, Typography } from 'antd';

interface ConfirmAddressProps {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  name: string;
}

const ConfirmUpdateAddress = ({ isOpen, setIsOpen, name }: ConfirmAddressProps) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      width={600}
      title='Confirmação de endereço concluída!'
      closable
      footer={
        <div className='flex justify-end'>
          <Button type='primary' onClick={handleClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-3'>
        <Typography.Text strong>{name}</Typography.Text>
        <Typography.Paragraph className='mb-0'>Seu endereço foi atualizado com sucesso.</Typography.Paragraph>
        <Typography.Paragraph className='mb-0'>
          Agradecemos por nos informar sobre a mudança. Isso garante que seus mimos e reconhecimentos do Programa Elite
          sejam enviados para o local correto.{' '}
          <Typography.Text strong>Em breve, você receberá seus prêmios no novo endereço.</Typography.Text>
        </Typography.Paragraph>
        <Typography.Paragraph className='mb-0'>
          Parabéns por suas conquistas e obrigado por fazer parte do Programa Elite!
        </Typography.Paragraph>
      </div>
    </Modal>
  );
};

export default ConfirmUpdateAddress;
